import * as Types from '../constants/Types';
import Coupon from './../models/Coupon';

const initialState = {
    isFetching: false,
    coupon: new Coupon()
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_COUPON:
            return { ...state, isFetching: true };
        case Types.SET_COUPON:
            return {
                ...state,
                coupon: action.couponData,
                isFetching: false
            };
        case Types.CLEAR_COUPON: 
            return initialState
        default: return state
    }
}